"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore-next-line importsNotUsedAsValues
require("react");
// @ts-ignore-next-line 7016
const react_notifications_1 = require("react-notifications");
exports.default = react_notifications_1.NotificationManager;
